import { secondaryMarketBatchApiConnector } from 'apiConnector/secondary-market/batch/api';
import { OrderType } from 'apiConnector/secondary-market/batch/model';
import { lastValueFrom } from 'rxjs';
import { getAvailableOrderTypes } from 'state/selectors/meta/secondary-market';
import { Thunk } from 'state/state.common';
import { secondaryMarketBatchActions } from 'state/workspaces/secondary-market/batch/actions';
import { httpClient } from 'utils/http/httpClient';

export const batchApi = secondaryMarketBatchApiConnector(httpClient);

export function makeSureIsLoadedForAllOrderTypesThunk(): Thunk<void> {
  return (dispatch, getState, _) => {
    const state = getState();
    const availableOrderTypes = getAvailableOrderTypes(state);
    availableOrderTypes.forEach(orderType => {
      dispatch(makeSureIsLoadedForOrderTypeThunk(orderType));
    });
  };
}

export function makeSureIsLoadedForOrderTypeThunk(orderType: OrderType): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        fromSecondaryMarketBatch: { selectStatusByOrderType },
      },
    },
  ) => {
    const state = getState();
    const status = selectStatusByOrderType(state, orderType);
    if (status === 'loading' || status === 'error' || status === 'success') {
      return;
    }
    dispatch(secondaryMarketBatchActions.reloadRequested(orderType));
    lastValueFrom(batchApi.reload(orderType))
      .then(response => {
        dispatch(secondaryMarketBatchActions.reloadSucceeded(orderType, response));
      })
      .catch(error => {
        dispatch(secondaryMarketBatchActions.reloadFailed(orderType, error));
      });
  };
}
